import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './interview-participant.reducer';

export const InterviewParticipantDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const interviewParticipantEntity = useAppSelector(state => state.interviewParticipant.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="interviewParticipantDetailsHeading">
          <Translate contentKey="fivePlusApp.interviewParticipant.detail.title">InterviewParticipant</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{interviewParticipantEntity.id}</dd>
          <dt>
            <span id="processStatus">
              <Translate contentKey="fivePlusApp.interviewParticipant.processStatus">Process Status</Translate>
            </span>
          </dt>
          <dd>{interviewParticipantEntity.processStatus}</dd>
          <dt>
            <span id="dailyCoGuestLink">
              <Translate contentKey="fivePlusApp.interviewParticipant.dailyCoGuestLink">Daily Co Guest Link</Translate>
            </span>
          </dt>
          <dd>{interviewParticipantEntity.dailyCoGuestLink}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.interviewParticipant.user">User</Translate>
          </dt>
          <dd>{interviewParticipantEntity.user ? interviewParticipantEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.interviewParticipant.interview">Interview</Translate>
          </dt>
          <dd>{interviewParticipantEntity.interview ? interviewParticipantEntity.interview.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/interview-participant" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/interview-participant/${interviewParticipantEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InterviewParticipantDetail;
